var map = {
	"./en/card_1_1.png": "Ph8F",
	"./es/card_1_1.png": "khzb",
	"./pt/card_1_1.png": "ITIj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UN3Q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_1_1\.png$
// module id = UN3Q
// module chunks = 0